import {  Layout, Row, Col} from 'antd';
import React, { Component} from "react";
import {NavLink} from "react-router-dom";


/** *
* *Footer used in all pages. It receives as param if it used in regular user view or admin/jury mode, for a propper link use
@param admin
@param jury
*/
class Foot extends Component {
  render() {
    const { Footer } = Layout;
    return (
        <Footer style={{backgroundColor:'#fac14e', position:'relative',bottom:'0px',left:'0px',right:'0px',flexShrink:0}}>
          <Row justify="center" align="middle" style={{ width:'100%', backgroundColor:'#fac14e',  marginBottom:'0px', bottom:'0px'}}>
            <Col xl={6} xs={24} sm={{span:6}}> <div style={{textAlign: 'center'}}>  <NavLink to={this.props.admin ? "/composicion/admin_bases":this.props.jury ? "/composicion/jury_bases": "/composicion/bases"} style={{color:'white'}}>Bases del concurso</NavLink> </div> </Col>
            <Col xl={4}xs={24} sm={{span:6}}> <div style={{textAlign: 'center'}}> <a style={{color:'white'}} href = "mailto: dirmusica@casa.cult.cu">dirmusica@casa.cult.cu</a></div></Col>
            <Col xl={{span:4, offset:2}} sm={{span:6}} xs={{span:24}} > <div style={{textAlign: 'center'}}><a style={{color:'white', textAlign: 'center'}} target="_blank" href="http://www.casadelasamericas.org/"> Sitio Oficial Casa de las Américas</a> </div></Col>
            <Col xl={4}xs={24}sm={{span:6}} > <div style={{textAlign: 'center'}}> <a style={{color:'white'}}target="_blank"  href="http://laventana.casa.cult.cu/"> La Ventana</a></div></Col>
            <Col xl={4} xs={24} sm={{span:24}}> <div style={{textAlign: 'center'}}> <NavLink to={this.props.admin ? "/composicion/admin_terminos":this.props.jury ? "/composicion/jury_terminos":"/composicion/terminos"} style={{color:'white'}}>Términos y condiciones de uso</NavLink> </div> </Col>
          </Row>
        </Footer>
    );
  }
}
export default Foot;


